<mat-card class="linkbox-card">
    <mat-card-content>
        <img class="card-img" src="assets/images/sura/resultados.png" />
        <p class="primary-color">{{ 'shared.resultsLinkbox.title' | translate:locale.language | uppercase }}</p>
        <span>{{ 'shared.resultsLinkbox.description' | translate:locale.language }}</span>
        <button mat-button color="accent" (click)="navigate()">{{ 'shared.resultsLinkbox.buttonText' | translate:locale.language | uppercase }}</button>
    </mat-card-content>
</mat-card>
